import { UPDATE_LEGALE_PAGES, UPDATE_USERS } from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    legalePages: 0,
    users: null,
};

const updateLegalePages = (state, action) => {
    return updateState(state, {
        legalePages: action.legalePages,
    });
};

const updateUsers = (state, action) => {
    return updateState(state, {
        users: action.users,
    });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_LEGALE_PAGES:
            return updateLegalePages(state, action);
        case UPDATE_USERS:
            return updateUsers(state, action);
        default:
            return state;
    }
};

export default reducer;
